import { db } from './DBUtils';
import { IPlace } from './interfaces/IPlace';
import { ILocation } from './interfaces/ILocation';
import { ITrail } from './interfaces/ITrail';
import { LatLng } from 'leaflet';
import { ITaxonomy } from './interfaces/ITaxonomy';

export class Place implements IPlace {
	id!: number;
	title!: string;
	image!: string | boolean;
	featured_video!: string | boolean;
	short_description!: string;
	description!: string;
	featured!: boolean;
	location!: ILocation;
	location_name!: string;
	fkTrails!: number[];
	trails: ITrail[];
	topics!: ITaxonomy[];
	tags!: ITaxonomy[];
	url!: string;
	external_url_description!: string;

	constructor(props: IPlace) {
		if (props.id) this.id = props.id;
		this.title = props.title;
		this.image = props.image;
		this.short_description = props.short_description;
		this.description = props.description;
		this.location = props.location;
		this.trails = [];
		this.topics = props.topics;
		this.url = props.url;
		this.external_url_description = props.external_url_description;

		Object.defineProperties(this, {
			trails: { value: [], enumerable: false, writable: true },
		});
	}

	toLatLng() {
		return new LatLng(this.location.lat, this.location.lng);
	}

	async loadRelationships() {
		this.trails = await db.trails
			.where('id')
			.anyOf(this.fkTrails)
			.toArray();
		return this;
	}

	public static async decorate(places: Place[]) {
		const new_list: Place[] = [];
		for (let ndx = 0; ndx < places.length; ndx++) {
			await places[ndx].loadRelationships();
			new_list.push(places[ndx]);
		}
		return new_list;
	}
}
